import { NgModule } from '@angular/core';

// NgFor, NgIF, pipes, etc
import { CommonModule } from '@angular/common';
// RouterLink -> sidebar
import { RouterModule } from '@angular/router';
import { MatPaginatorIntl } from '@angular/material/paginator';

// Markdown formatting
import { MarkdownModule } from 'ngx-markdown';

// Pipes

// Components
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FileIconComponent } from './file-icon/file-icon.component';
import { FooterComponent } from './footerMenu/footer.component';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { ModalVideoComponent } from '../components/modal-video/modal-video.component';
import { ModalPaywallComponent } from '../components/modal-paywall/modal-paywall.component';
import { ModalPdfComponent } from '../components/modal-pdf/modal-pdf.component';

// Translator
import { TranslocoModule } from '@jsverse/transloco';
import { LoaderComponent } from './loader/loader.component';

//directive
import { HasRoleDirective } from '../directives/has-role.directive';
import { SectionButtonComponent } from './section-button/section-button.component';
import { AppsCardComponent } from './apps-card/apps-card.component';
import { AppsCardsListComponent } from './apps-cards-list/apps-cards-list.component';
import { PrimaryButtonComponent } from './primary-button/primary-button.component';
import { NewsComponent } from './news/news.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { FormsModule } from '@angular/forms';
import { NoResourcesComponent } from './no-resources/no-resources.component';

import { SpanishPaginatorIntl } from '../material-spanish-paginator-intl.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GeneralChartComponent } from './quiz-results-charts/general-chart/general-chart.component';
import { TimeDisplayComponent } from './quiz-results-charts/time-display/time-display.component';
import { ChartWithCategoriesComponent } from './quiz-results-charts/chart-with-categories/chart-with-categories.component';
import { QuizQuestionsComponent } from './quiz-questions/quiz-questions.component';
import { FixComponent } from './fix/fix.component';
import { SelectComponent } from './select/select.component';
import { BarHorizontalComponent } from './bar-horizontal/bar-horizontal.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SelectableCardComponent } from './selectable-card/selectable-card.component';
import { TabSelectorComponent } from './tab-selector/tab-selector.component';
import { AIGeneratorButtonComponent } from './ai-generator-button/ai-generator-button.component';
import { ReturnButtonComponent } from './return-button/return-button.component';
import { NoDataContainerComponent } from './no-data-container/no-data-container.component';
import { SkeletonComponent } from './skeleton/skeleton.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    TranslocoModule,
    FormsModule,
    NgxChartsModule,
    MarkdownModule.forRoot(),
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    FileIconComponent,
    FooterComponent,
    NopagefoundComponent,
    ModalVideoComponent,
    ModalPaywallComponent,
    ModalPdfComponent,
    LoaderComponent,
    HasRoleDirective,
    SectionButtonComponent,
    AppsCardComponent,
    AppsCardsListComponent,
    PrimaryButtonComponent,
    NewsComponent,
    SearchBarComponent,
    NoResourcesComponent,
    GeneralChartComponent,
    TimeDisplayComponent,
    ChartWithCategoriesComponent,
    QuizQuestionsComponent,
    FixComponent,
    SelectComponent,
    BarHorizontalComponent,
    ChatbotComponent,
    SelectableCardComponent,
    TabSelectorComponent,
    AIGeneratorButtonComponent,
    ReturnButtonComponent,
    NoDataContainerComponent,
    SkeletonComponent,
  ],
  exports: [
    BarHorizontalComponent,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    FileIconComponent,
    FooterComponent,
    ModalVideoComponent,
    ModalPaywallComponent,
    ModalPdfComponent,
    TranslocoModule,
    LoaderComponent,
    HasRoleDirective,
    SectionButtonComponent,
    AppsCardComponent,
    AppsCardsListComponent,
    PrimaryButtonComponent,
    NewsComponent,
    SearchBarComponent,
    NoResourcesComponent,
    NgxChartsModule,
    GeneralChartComponent,
    TimeDisplayComponent,
    ChartWithCategoriesComponent,
    QuizQuestionsComponent,
    FixComponent,
    SelectComponent,
    ChatbotComponent,
    SelectableCardComponent,
    TabSelectorComponent,
    AIGeneratorButtonComponent,
    ReturnButtonComponent,
    NoDataContainerComponent,
    SkeletonComponent,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: SpanishPaginatorIntl }],
})
export class SharedModule {}
